
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sign/automation",
      function () {
        return require("private-next-pages/sign/automation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sign/automation"])
      });
    }
  